
<div
  id="el-newsletter"
  class="my-28 mx-auto max-w-[90rem] font-rubik font-normal overflow-visible bg-[#EDE9E3] border border-[#D4CBBF] rounded-md h-[29.375rem] flex justify-between min-h-0 min-w-0"
>
  <div id="el-newsletter-form-container" class="flex flex-col gap-12 p-16 max-w-[38rem]">
    <div class="tracking-[-0.02rem] flex flex-col gap-6">
      <h3 class="text-[2.5rem] leading-[3rem]">
        Sign up for our newsletter
      </h3>
      <p class="m-0 p-0 text-[1.125rem] leading-[1.6875rem]">
        Stay up to date with the latest news and updates from our team.
      </p>
    </div>
    <div id="el-newsletter-actions-container" class="flex flex-col gap-4 pt-4">
      <div id="el-newsletter-form-fields-container" class="flex items-center gap-2 text-[1rem] leading-[1.5rem] tracking-[-0.0125rem]">
        <input
          type="email"
          v-model="email"
          @keyup.enter="signNewsletter"
          placeholder="Enter your email"
          class="p-3 pl-4 flex-1 bg-white border border-[#D4CBBF] rounded-lg outline-none"
        >
        <button
          id="el-newsletter-sign-up-button"
          class="shrink-0 rounded-full px-7 py-3 bg-[#334155] text-white hover:bg-[#1A202C]"
          @click="signNewsletter"
          :disabled="loading"
        >
          <span v-if="loading">Signing Up...</span>
          <span v-else>Sign Up</span>
        </button>
      </div>
      <p>
        By clicking Sign Up you're confirming that you agree with our Terms and Conditions.
      </p>
    </div>
  </div>
  <img
    :src="engineerImageUrl"
    alt="Engineer"
    class="max-h-[120%] self-end"
  />
</div>
